import React from "react";
import { Pagination } from "@mui/material";
import moment from "moment";
import CopyToClipboard from "react-copy-to-clipboard";
import { reactIcons } from "../../utils/icons";
import { toast } from "react-toastify";

const WalletAddressTable = ({
  handleNavigate,
  headings,
  pageNumber,
  listData,
  handlePage,
  take,
  setPageNumber
}) => {
  // copy wallet address function
  const handleCopy = () => {
    toast.success("Copied Successfully");
  };
  return (
    <>
      <div className="overflow-x-auto custom-scroll opacity-[100%] duration-1000">
        <table className="text-xs leading-6 font-normal min-w-[1290px] w-full">
          <thead>
            <tr className="bg-gradient-red rounded-lg text-white">
              {headings.map((item, index) => {
                return (
                  <th key={item} className="group">
                    <div
                      className={`py-1 my-1 flex items-center justify-center text-left font-semibold ${
                        index === headings.length - 1
                          ? "border-r-0"
                          : "border-white border-r"
                      }`}
                    >
                      {item}
                    </div>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {listData.data?.length > 0 ? (
              listData?.data &&
              listData?.data?.map((item, index) => {
                return (
                  <tr
                    className=" bg-[#181B1D] h-[42px] border-2 border-[#393939] text-white mb-2"
                    key={index}
                  >
                    <td>
                      <div className="text-center border-r border-white">
                        {(pageNumber - 1) * take + index + 1}
                      </div>
                    </td>
                    <td>
                      <div className="text-center border-r border-white">
                        {item?.userEmail}
                      </div>{" "}
                    </td>
                    <td>
                      <div className="text-center border-r border-white">
                        {item?.userMobile}
                      </div>{" "}
                    </td>
                    <td>
                      <div className="text-center border-r border-white">
                        {moment(item?.payoutCreatedAt).format(
                          "YYYY-MM-DD hh:mm A"
                        )}
                      </div>{" "}
                    </td>

                    <td>
                      <div className="text-center">
                        <div className=" flex items-center justify-center gap-2 p-2.5 rounded-lg ">
                          <div>
                            {item?.walletAddress.slice(0, 6) +
                              "..." +
                              item?.walletAddress.slice(38, 42)}
                          </div>
                          <CopyToClipboard
                            text={item?.walletAddress}
                            onCopy={handleCopy}
                          >
                            <button type="button"> {reactIcons.copy}</button>
                          </CopyToClipboard>
                        </div>
                      </div>{" "}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={5} className="text-white text-center py-4">
                  Not Available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="py-4 flex justify-end items-center">
        <Pagination
          count={Math.ceil(listData.count / take)}
          onChange={(e, page) => {
            handlePage(e, page);
            setPageNumber(page);
          }}
          page={pageNumber}
          hideNextButton={pageNumber >= Math.ceil(listData.count / take)}
          hidePrevButton={pageNumber <= 1}
          sx={{
            "& .MuiPaginationItem-root": {
              background: "transparent",
              color: "white",
              "&:focus": {
                background: "none",
                outline: "none",
                boxShadow: "none"
              }
            },
            "& .MuiPaginationItem-previousNext": {
              background:
                "linear-gradient(292deg, #69CEA6 0%, #000000 75%, #000000 100%)",
              color: "white",
              "&:hover": {
                background:
                  "linear-gradient(292deg, #69CEA6 0%, #000000 75%, #000000 100%)"
              },
              "&:focus": {
                background:
                  "linear-gradient(292deg, #69CEA6 0%, #000000 75%, #000000 100%)",
                outline: "none",
                boxShadow: "none"
              }
            },
            "& .Mui-selected": {
              background:
                "linear-gradient(292deg, #69CEA6 0%, #000000 75%, #000000 100%)",
              color: "#fff",
              fontWeight: "bold",
              borderRadius: "50%",

              "&:focus": {
                background:
                  "linear-gradient(292deg, #69CEA6 0%, #000000 75%, #000000 100%)",
                outline: "none",
                boxShadow: "none"
              }
            }
          }}
        />
      </div>
    </>
  );
};
export default WalletAddressTable;
